/**
 * @generated SignedSource<<84a013e8a10d853e070bba24db2c1623>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespContentModuleSelector_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SbRespContentModuleLanding_viewer">;
  readonly " $fragmentType": "SbRespContentModuleSelector_viewer";
};
export type SbRespContentModuleSelector_viewer$key = {
  readonly " $data"?: SbRespContentModuleSelector_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespContentModuleSelector_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespContentModuleSelector_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespContentModuleLanding_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "64ddb45ca8e201021658c0c8175e2612";

export default node;
